import gsap from 'gsap';
import Swiper, { Pagination } from 'swiper';

Swiper.use([Pagination]);

const init = () => {
    const slider = document.querySelector('.js-specialty-range-slider');
    if (slider) {
        const opts = {
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1280: {
                    slidesPerView: 3,
                },
                1536: {
                    centeredSlides: false,
                    slidesPerView: 3,
                },
            },
            grabCursor: true,
            loop: true,
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
                lockClass: 'opacity-0',
            },
            observer: true,
            slidesPerView: 1,
            spaceBetween: 30,
        };

        const swiper = new Swiper(slider, opts); // eslint-disable-line no-unused-vars

        // Get all Swiper slide items within the slider
        const swiperItems = slider.querySelectorAll('.swiper-slide');
        swiperItems.forEach((item) => {
            item.addEventListener('mouseenter', () => {
                gsap.to(item, {
                    duration: 0.2,
                    boxShadow: `inset 0 0 0 4px ${item.dataset.color}`,
                    borderColor: item.dataset.color,
                    ease: 'power2.out',
                });
            });

            item.addEventListener('mouseleave', () => {
                gsap.to(item, {
                    duration: 0.2,
                    boxShadow: 'none',
                    borderColor: '#bcbcbc',
                    ease: 'power2.out',
                });
            });
        });
    }
};

export default init;
